<template>
<div>
    <p>
        <m-settings-organization-team-members
            :profile="profile"
            :show_search_bar="false"
            style="margin-bottom: 30px"
            :simple_create_team_member_dialog="true"
            v-on:add-team-member="addTeamMember"
            v-on:patch-employee="onPatchEmployee"
        />

        <v-switch
            label="This section is complete (does not mark the 'Setup your team members' section as complete on the welcome screen)"
            v-model="profile.provision_info.complete_team"
            v-on:change="onChangeCompleteSwitch"
        />
    </p>

</div>
</template>

<script>
export default {
    props: {
         profile: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        onChangeCompleteSwitch() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/provision/provision-info',
            
                'params' : this.profile.provision_info,
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to mark the rate card section as complete',
            });
        },

        addTeamMember(new_team_member_data)
        {
            this.$rc.createEmployee(
                new_team_member_data, 
                () => {
                    this.$emit('reload');
                },
                (message) => { 
                    this.show_loading = false;
                    alert(message) 
                } 
            );
        },

        onPatchEmployee(changes)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/employees',
            
                'params' : changes,
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to update employee account',
            });
        },
    },
}
</script>

<style lang="scss" scoped>

</style>